// extracted by mini-css-extract-plugin
export default {"card":"Card_card__uFbbj","cardDesc":"Card_cardDesc__fQKkV","cardBg":"Card_cardBg__8G6Ns","absRow":"Card_absRow__DdgVo","redColor":"Card_redColor__oHvWH","row":"Card_row__9rqM0"};